interface ChatFABProps {
  unreadCount: number;
  onClick: () => void;
}

export function ChatFAB({ unreadCount, onClick }: ChatFABProps) {
  return (
    <button
      onClick={onClick}
      aria-label="Open AI chat"
      className="fixed bottom-24 right-4 z-30 w-14 h-14 rounded-full bg-accent text-white shadow-floating hover:brightness-110 active:scale-95 transition-all"
    >
      <span className="material-icons-round">chat</span>
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-error text-white text-[10px] font-bold flex items-center justify-center">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
}

export default ChatFAB;
